import React from "react";
import { Avatar, Box, createStyles, Text } from "@mantine/core";



interface Details {
    heading?:string
    dob?:any
    gender?:string
mobile?:any
  name?: string;
  address?:string
  email?:string
  moreDetails?:boolean
  city?:string
  country?:string
  age?:any
}

export const PatientDetails: React.FC<Details> = ({
  heading,
  dob,
  gender,
  mobile,
  name,
  address,
  email,
  moreDetails,
  city,
  country,age
}) => {
  const useStyles = createStyles(() => ({
    mainBox: {
      border: "1px solid #EDEDED",
      width: "100%",
      padding: "16px",
      borderRadius: "10px",
      gap: "24px",
      display: "flex",
      flexDirection: "column",
      // minWidth:"100px",overflowX:"auto"
    },
    Box1: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      alignItems:"center"
    },
    Box2: {
      display: "flex",
      flexDirection: "row",
      gap: "60px",
      overflowX:"auto"
    },
    details: {
      display: "flex",
      flexDirection: "column",
      alignContent: "space-between",
      gap:"8px"
    },
    heading: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "22px",
      color: "#818999",
    },
    value: {
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "22px",
      color: "#262930",
    },
  }));

  const { classes } = useStyles();

  return (
    <Box className={classes.mainBox}>
      <Box className={classes.Box1}>
        <Avatar src={""} />
        <Text fz="lg" fw={800}>
          {name ?? "--"}
        </Text>
      </Box>
      <Box className={classes.Box2}>
        <Box className={classes.details}>
          <Box className={classes.heading}>DOB</Box>
          <Box className={classes.value}>{dob ?? "--"}</Box>
        </Box>
        <Box className={classes.details}>
          <Box className={classes.heading}>Gender</Box>
          <Box
            className={classes.value}
            style={{ textTransform: "capitalize" }}
          >
            {gender ?? "--"}
          </Box>
        </Box>
        <Box className={classes.details}>
          <Box className={classes.heading}>Mobile</Box>
          <Box className={classes.value}>{mobile ?? "--"}</Box>
        </Box>
        {!moreDetails && (
          <>
            <Box className={classes.details}>
              <Box className={classes.heading}>Email</Box>
              <Box className={classes.value}>{email ?? "--"}</Box>
            </Box>
            <Box className={classes.details}>
              <Box className={classes.heading}>Address</Box>
              <Box className={classes.value}>{address ?? "--"}</Box>
            </Box>
          </>
        )}

        {moreDetails && (
          <>
            <Box className={classes.details}>
              <Box className={classes.heading}>Age</Box>
              <Box className={classes.value}>{age ?? "--"}</Box>
            </Box>
            <Box className={classes.details}>
              <Box className={classes.heading}>City</Box>
              <Box className={classes.value}>{city ?? "--"}</Box>
            </Box>
            <Box className={classes.details}>
              <Box className={classes.heading}>Country</Box>
              <Box className={classes.value}>{country ?? "--"}</Box>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
